import { render } from "./OfficerGroupsView.vue?vue&type=template&id=381ca460&scoped=true"
import script from "./OfficerGroupsView.vue?vue&type=script&lang=js"
export * from "./OfficerGroupsView.vue?vue&type=script&lang=js"

import "./OfficerGroupsView.vue?vue&type=style&index=0&id=381ca460&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381ca460"]])

export default __exports__